module.exports = __webpack_public_path__ + "img/4.e14a2b9b.png";